<img *ngFor="let logo of logos" src="/assets/domains/subscription-plans/companies-logos/{{ logo }}.webp" />
